/* =====================================================================
   KAUFBARE PUNKTE AUF DEM KOLLEKTIONS-HERO - DIE UMRECHNUNG

   WARUM ES DIESES SKRIPT UEBERHAUPT GIBT
   -------------------------------------
   Das Hero-Bild fuellt seinen Rahmen per CSS mit object-fit: cover. Der
   Rahmen ist so hoch wie ein Anteil des Bildschirms (--custom-height in
   vh), also bei jedem Besucher anders. Was nicht hineinpasst, wird
   abgeschnitten - am Live-Shop gemessen: am Desktop verschwinden 33 % der
   Bildhoehe, am Handy 74 % der Bildbreite.

   Deshalb werden die Punkte in Prozent des ORIGINALBILDES gespeichert und
   nicht in Prozent der sichtbaren Flaeche. Ein Punkt bei 50 % / 50 % des
   Originals sitzt am Desktop bei 50 % / 61 % der sichtbaren Flaeche - 81
   Pixel daneben, wenn man die Umrechnung weglaesst.

   Liquid kennt die Fenstermasse des Besuchers nicht. Also rechnet der
   Browser. Diese Datei macht dieselbe Rechnung wie die Funktion rectFor
   in app/ausschnitt.tsx (Zeile 52) des Cockpits - nur umgekehrt herum:
   das Cockpit zeichnet aus der Rechnung den Rahmen ueber die Vorschau,
   das Theme setzt aus derselben Rechnung die Punkte.

   Kein Framework, keine Abhaengigkeit, alles in einer Kapsel (IIFE).
   ===================================================================== */

(function () {
  'use strict';

  /* Wird der Hero zweimal auf einer Seite gerendert, laedt Shopify diese
     Datei auch zweimal. Ohne diese Sperre haengen dann doppelte
     Beobachter an Fenster und Bild. */
  if (window.__heroPunkteLaeuft) return;
  window.__heroPunkteLaeuft = true;

  var EBENEN = '[data-hero-punkte]';
  var BEREIT = 'hero-punkte--bereit';

  /* -------------------------------------------------------------------
     1. Das zugehoerige Bild finden.

     Aufbau im Theme (snippets/kollektions-hero-geplant.liquid):

       .image-hero__inner
         .image-hero__image-container
            .image .image-hero__image      <- vom Snippet 'image'
               img.image__img              <- das gesuchte Bild
         .image-hero__overlay
         .image-hero__text-container-wrapper
            ... a.image-hero__image-link   <- die ganzflaechige Verknuepfung
         .hero-punkte                      <- unsere Ebene, ganz zuletzt

     Bewusst NICHT einfach das erste img im Hero nehmen: in den Textblock
     kann ein Bild-Baustein gesetzt sein, der ebenfalls ein img enthaelt.
     ------------------------------------------------------------------- */
  function bildZu(ebene) {
    var rahmen = ebene.parentElement;
    if (!rahmen) return null;
    return (
      rahmen.querySelector('.image-hero__image img') ||
      rahmen.querySelector('.image-hero__image-container img') ||
      null
    );
  }

  /* -------------------------------------------------------------------
     2. object-position lesen.

     Der Bildschwerpunkt steckt entweder in der CSS-Variablen
     --focal-alignment (Snippet 'image') oder in einer !important-Regel,
     die das Hero-Snippet fuer den geplanten Cockpit-Slot schreibt
     (Zeile 268: object-position: 50% 0% !important). Statt beides
     nachzubauen fragen wir den Browser nach dem fertigen Ergebnis -
     messen statt schaetzen.

     Rueckgabe je Achse: { einheit: 'prozent'|'px', wert: Zahl }
     Prozente kommen als Anteil zurueck (0.5 statt "50%").
     ------------------------------------------------------------------- */
  function einWert(text) {
    if (text === 'left' || text === 'top') return { einheit: 'prozent', wert: 0 };
    if (text === 'right' || text === 'bottom') return { einheit: 'prozent', wert: 1 };
    if (text === 'center') return { einheit: 'prozent', wert: 0.5 };
    if (text.charAt(text.length - 1) === '%') {
      return { einheit: 'prozent', wert: (parseFloat(text) || 0) / 100 };
    }
    return { einheit: 'px', wert: parseFloat(text) || 0 };
  }

  function schwerpunkt(text) {
    var mitte = { einheit: 'prozent', wert: 0.5 };
    var teile = String(text || '').trim().split(/\s+/);

    /* Ein einzelner Wert bedeutet: waagerecht dieser Wert, senkrecht
       zentriert. Mehr als zwei Werte (Schreibweise "right 20px bottom
       10px") kommt im Theme nicht vor - dann bleiben wir bei der Mitte,
       statt falsch zu raten. */
    if (teile.length === 1 && teile[0] !== '') teile.push('center');
    if (teile.length !== 2) return { x: mitte, y: mitte };

    /* Schluesselwoerter duerfen in beliebiger Reihenfolge stehen
       ("top left"). Die meisten Browser normalisieren das zu Prozenten,
       Safari nicht immer - also tauschen wir bei Bedarf. */
    var erst = teile[0];
    var zweit = teile[1];
    if (erst === 'top' || erst === 'bottom' || zweit === 'left' || zweit === 'right') {
      var puffer = erst; erst = zweit; zweit = puffer;
    }
    return { x: einWert(erst), y: einWert(zweit) };
  }

  /* -------------------------------------------------------------------
     3. DIE RECHNUNG - welcher Teil des Originalbildes ist sichtbar?

     Gegeben:
       natB, natH  Originalmasse des Bildes  (naturalWidth/naturalHeight)
       kB,   kH    Masse des Bildkastens im Layout (siehe 2b - NICHT
                   getBoundingClientRect, das zaehlt die Einblendung mit)
       pos         object-position

     Schritt 1 - Massstab. Bei cover wird das Bild so weit vergroessert,
     bis es den Rahmen in BEIDEN Richtungen mindestens ausfuellt. Also der
     GROESSERE der beiden Faktoren:

         massstab = max(kB / natB, kH / natH)

     Damit ist die dargestellte Groesse des Bildes:

         dB = natB * massstab      dH = natH * massstab

     Mindestens eine der beiden ist groesser als der Rahmen - das ist der
     Ueberhang, der abgeschnitten wird.

     Schritt 2 - Versatz. object-position verschiebt das dargestellte Bild
     im Rahmen. Ein Prozentwert P heisst: der Punkt bei P % des BILDES
     liegt auf dem Punkt bei P % des RAHMENS. Daraus folgt

         versatzX = (kB - dB) * P          (negativ, weil dB > kB)

     Bei einer Pixelangabe ist der Versatz einfach dieser Wert.

     Schritt 3 - zurueck in Originalpixel. Der sichtbare Ausschnitt faengt
     dort an, wo der Rahmen anfaengt. In Koordinaten des dargestellten
     Bildes ist das -versatzX; geteilt durch den Massstab ergibt das
     Originalpixel:

         vx = -versatzX / massstab         vy = -versatzY / massstab
         vb =  kB / massstab               vh =  kH / massstab

     GEGENPROBE mit rectFor aus app/ausschnitt.tsx: Setzt man dort einen
     Prozentwert ein, ist vx = (natB - vb) * P. Und hier:
         vx = -(kB - dB) * P / massstab
            = (dB - kB) * P / massstab
            = (natB - kB/massstab) * P
            = (natB - vb) * P
     Dieselbe Zahl. Cockpit und Theme rechnen also nachweislich gleich.
     ------------------------------------------------------------------- */
  /* -------------------------------------------------------------------
     2b. MESSEN OHNE VERZERRUNG

     Das Theme blendet das Hero-Bild ein: Regel
     .animation--slideshow .image--animate .image__img setzt
     transform: scale(1.3) und faehrt es in 1,2 s auf 1 zurueck.

     getBoundingClientRect zaehlt diese Verzerrung MIT. Wer waehrend der
     Einblendung misst, rechnet mit einem um 30 % zu grossen Bild und
     setzt die Punkte daneben - und niemand rechnet je nach, weil ein
     transform weder resize noch ResizeObserver ausloest.

     Ein transform aendert das LAYOUT nicht. offsetWidth und offsetLeft
     liefern darum die wahren Masse, ganz gleich wann gemessen wird.

     Am 09.09.2026 nachgemessen: mit getBoundingClientRect landete der
     Punkt bei 71,3 % statt 66,7 % - gut 4,6 Prozentpunkte daneben.
     ------------------------------------------------------------------- */

  /* Layout-Rechteck eines Elements. offsetLeft zaehlt vom offsetParent
     aus; wir summieren die Kette. Gebraucht wird spaeter nur die
     DIFFERENZ zweier Elemente aus demselben Ast - alle gemeinsamen
     Vorfahren heben sich dabei wieder auf. */
  function layoutRahmen(el) {
    var links = 0, oben = 0, k = el;
    while (k) { links += k.offsetLeft; oben += k.offsetTop; k = k.offsetParent; }
    return { left: links, top: oben, width: el.offsetWidth, height: el.offsetHeight };
  }

  /* Dasselbe, aber auf den Inhaltskasten verkleinert: object-fit
     beschneidet gegen den Inhalt, nicht gegen Rand und Polster. Beim
     heutigen Theme sind beide null - die Rechnung bleibt trotzdem
     richtig, falls jemand dem Bild spaeter einen Rand gibt. */
  function inhaltsRahmen(el, stil) {
    var r = layoutRahmen(el);
    var zahl = function (t) { return parseFloat(t) || 0; };
    var l = zahl(stil.borderLeftWidth) + zahl(stil.paddingLeft);
    var o = zahl(stil.borderTopWidth) + zahl(stil.paddingTop);
    var re = zahl(stil.borderRightWidth) + zahl(stil.paddingRight);
    var u = zahl(stil.borderBottomWidth) + zahl(stil.paddingBottom);
    return {
      left: r.left + l, top: r.top + o,
      width: r.width - l - re, height: r.height - o - u
    };
  }

  function sichtbarerAusschnitt(bild) {
    var natB = bild.naturalWidth;
    var natH = bild.naturalHeight;
    if (!natB || !natH) return null;

    var stil = window.getComputedStyle(bild);

    /* Layout statt getBoundingClientRect - Begruendung siehe 2b. */
    var kasten = inhaltsRahmen(bild, stil);
    var kB = kasten.width;
    var kH = kasten.height;
    if (!kB || !kH) return null;

    /* Der Hero benutzt cover. Sollte jemand contain einstellen, ist der
       KLEINERE Faktor richtig - dann wird nichts abgeschnitten. */
    var deckend = stil.objectFit !== 'contain';
    var massstab = deckend
      ? Math.max(kB / natB, kH / natH)
      : Math.min(kB / natB, kH / natH);
    if (!massstab || !isFinite(massstab)) return null;

    var dB = natB * massstab;
    var dH = natH * massstab;

    var pos = schwerpunkt(stil.objectPosition);
    var versatzX = pos.x.einheit === 'px' ? pos.x.wert : (kB - dB) * pos.x.wert;
    var versatzY = pos.y.einheit === 'px' ? pos.y.wert : (kH - dH) * pos.y.wert;

    return {
      natB: natB,
      natH: natH,
      kasten: kasten,
      vx: -versatzX / massstab,
      vy: -versatzY / massstab,
      vb: kB / massstab,
      vh: kH / massstab
    };
  }

  /* -------------------------------------------------------------------
     4. Punkte setzen.

     Der Punkt kommt als Prozent des Originalbildes. Umgerechnet wird in
     zwei Stufen:

       a) Originalprozent -> Anteil der sichtbaren Flaeche (0 bis 1)
       b) Anteil          -> Prozent der Punkt-Ebene

     Stufe b ist noetig, weil die Ebene und das Bild theoretisch
     unterschiedlich gross sein koennen (etwa wenn das Theme spaeter einen
     Rand um das Bild legt). Wir rechnen darum ueber die tatsaechlichen
     Rechtecke beider Elemente statt anzunehmen, sie waeren deckungsgleich.

     Punkte ausserhalb des sichtbaren Bereichs werden ausgeblendet - sie
     wuerden sonst am Rand kleben und auf das falsche Motiv zeigen.
     ------------------------------------------------------------------- */
  function setzen(ebene) {
    var bild = bildZu(ebene);
    if (!bild) return;
    if (!bild.complete || !bild.naturalWidth) return;

    /* Die Ebene liegt absolut. Sollte ihr Elternteil wider Erwarten nicht
       positioniert sein, wuerde sie aus dem Hero herausfallen. Einmal
       nachmessen und nur dann nachhelfen. */
    var rahmen = ebene.parentElement;
    if (rahmen && window.getComputedStyle(rahmen).position === 'static') {
      rahmen.style.position = 'relative';
    }

    var a = sichtbarerAusschnitt(bild);
    if (!a) return;

    var ebeneKasten = layoutRahmen(ebene);
    if (!ebeneKasten.width || !ebeneKasten.height) return;

    var punkte = ebene.querySelectorAll('.hero-punkte__punkt');
    for (var i = 0; i < punkte.length; i++) {
      var punkt = punkte[i];
      var x = parseFloat(punkt.getAttribute('data-hp-x'));
      var y = parseFloat(punkt.getAttribute('data-hp-y'));
      if (isNaN(x) || isNaN(y)) { punkt.style.display = 'none'; continue; }

      /* a) Prozent des Originals -> Originalpixel -> Anteil des Ausschnitts */
      var anteilX = (x / 100 * a.natB - a.vx) / a.vb;
      var anteilY = (y / 100 * a.natH - a.vy) / a.vh;

      if (anteilX < 0 || anteilX > 1 || anteilY < 0 || anteilY > 1) {
        punkt.style.display = 'none';
        continue;
      }

      /* b) Anteil des Ausschnitts -> Prozent der Punkt-Ebene */
      var linksPx = (a.kasten.left - ebeneKasten.left) + anteilX * a.kasten.width;
      var obenPx = (a.kasten.top - ebeneKasten.top) + anteilY * a.kasten.height;

      punkt.style.display = '';
      punkt.style.left = (linksPx / ebeneKasten.width * 100) + '%';
      punkt.style.top = (obenPx / ebeneKasten.height * 100) + '%';
    }

    /* Erst jetzt duerfen die Punkte erscheinen - Einzelheiten in 4b. */
    zeigen(ebene, bild);
  }

  /* -------------------------------------------------------------------
     4b. WANN DIE PUNKTE ERSCHEINEN DUERFEN

     Das Hero-Bild wird mit transform: scale(1.3) eingeblendet und faehrt
     in 1,2 s auf Normalgroesse zurueck, Kurve cubic-bezier(.33, 0, 0, 1)
     - am 09.09.2026 am Live-Shop nachgemessen. Solange das laeuft, steht
     das MOTIV nicht dort, wo die Rechnung es erwartet; ein Punkt saehe
     sichtbar daneben aus.

     Wir warten deshalb nicht auf eine Uhr, sondern SEHEN NACH: Bild fuer
     Bild wird der tatsaechliche Massstab gelesen. Sobald er naeher als
     1,5 % an 1 liegt, blenden die Punkte auf.

     Warum 1,5 %: Das Bild waechst um seinen Mittelpunkt. Ein Punkt, der
     16,7 % neben der Mitte sitzt, verschiebt sich dabei um
     1,5 % x 16,7 % = 0,25 % der Bildbreite. Bei 1425 px sind das 3,6 px,
     ein Sechstel des Punktdurchmessers - nicht zu sehen.

     Wegen der weichen Auslaufkurve ist diese Schwelle schon nach rund
     70 % der Einblendung erreicht, also bei etwa 0,84 s statt 1,2 s. Der
     Punkt kommt dadurch, WAEHREND das Bild zur Ruhe kommt, statt lange
     danach. Zusammen mit dem 700-ms-Aufblenden aus dem Stilblatt geht
     beides ineinander ueber.

     Die Zaehlung der Bilder ist nur die Notbremse: Kaeme nie ein
     passender Wert, blieben die Punkte sonst fuer immer unsichtbar.
     ------------------------------------------------------------------- */

  var SCHWELLE = 0.015;
  var HOECHSTZAHL_BILDER = 180;   /* rund 3 s bei 60 Bildern je Sekunde */

  /* Aus "matrix(1.3, 0, 0, 1.3, 0, 0)" den waagrechten Massstab lesen.
     Bewusst ohne regulaeren Ausdruck. Die erste Zahl in der Klammer ist
     bei matrix wie bei matrix3d der gesuchte Wert. */
  function massstabVon(text) {
    if (!text || text === "none") return 1;
    var auf = text.indexOf("(");
    var zu = text.indexOf(")");
    if (auf < 0 || zu < auf) return 1;
    var erste = parseFloat(text.slice(auf + 1, zu).split(",")[0]);
    return isFinite(erste) ? Math.abs(erste) : 1;
  }

  function zeigen(ebene, bild) {
    if (ebene.classList.contains(BEREIT)) return;
    if (ebene.__hpWacht) return;   /* es wacht schon jemand */

    var fertig = function () {
      ebene.__hpWacht = false;
      ebene.classList.add(BEREIT);
    };

    if (typeof window.requestAnimationFrame !== "function") { fertig(); return; }

    var bilder = 0;
    var nachsehen = function () {
      if (ebene.classList.contains(BEREIT)) { ebene.__hpWacht = false; return; }
      var massstab = 1;
      try {
        massstab = massstabVon(window.getComputedStyle(bild).transform);
      } catch (e) { massstab = 1; }
      if (Math.abs(massstab - 1) <= SCHWELLE) { fertig(); return; }
      bilder++;
      if (bilder > HOECHSTZAHL_BILDER) { fertig(); return; }
      window.requestAnimationFrame(nachsehen);
    };

    ebene.__hpWacht = true;
    nachsehen();
  }

  /* -------------------------------------------------------------------
     5. Wann gerechnet wird.
     ------------------------------------------------------------------- */
  function alleSetzen() {
    var ebenen = document.querySelectorAll(EBENEN);
    for (var i = 0; i < ebenen.length; i++) setzen(ebenen[i]);
  }

  var wartend = null;
  function entprellt() {
    if (wartend) clearTimeout(wartend);
    wartend = setTimeout(function () {
      wartend = null;
      alleSetzen();
    }, 120);
  }

  function anmelden(ebene) {
    if (ebene.__heroPunkteAngemeldet) return;
    ebene.__heroPunkteAngemeldet = true;

    var bild = bildZu(ebene);
    if (bild) {
      /* Vor dem load-Ereignis sind naturalWidth/naturalHeight noch 0 -
         ohne diese Zeile blieben die Punkte bei einem kalten Cache
         unsichtbar. */
      bild.addEventListener('load', function () { setzen(ebene); });

      /* Der Rahmen aendert sich nicht nur beim Fenster-Resize, sondern
         auch, wenn die Kopfzeile aufklappt oder eine App etwas einfuegt.
         ResizeObserver merkt das; wo es ihn nicht gibt, reicht resize. */
      if (typeof ResizeObserver === 'function') {
        new ResizeObserver(entprellt).observe(bild);
      }
    }
    setzen(ebene);
  }

  function starten() {
    var ebenen = document.querySelectorAll(EBENEN);
    for (var i = 0; i < ebenen.length; i++) anmelden(ebenen[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', starten);
  } else {
    starten();
  }

  window.addEventListener('resize', entprellt);
  window.addEventListener('orientationchange', entprellt);

  /* Im Theme-Editor wird eine Abteilung neu geladen, ohne dass die Seite
     neu laedt. Dann muss die neue Ebene angemeldet werden. */
  document.addEventListener('shopify:section:load', starten);
  document.addEventListener('shopify:section:reorder', entprellt);
})();
